module.exports = __webpack_public_path__ + "media/sweepstakes_and_promotions/contest_raf-eda6b22e.png";